var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { injectIntl } from "@irati/utils/lang";
import { SSO_TYPE_SAML } from "@irati/sso/constants/signUpOptions";
import authentication from "@irati/auth";
import SAMLSingleSignOn from "@irati-web/admin/src/components/Settings/CompanySignUpSettings/SAMLSingleSignOn";
import notify from "@irati/utils/notify";
var PromoMaterials = /** @class */ (function (_super) {
    __extends(PromoMaterials, _super);
    function PromoMaterials() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkIfStepIsCompletable = function () {
            var _a = _this.props, setIsStepCompletable = _a.setIsStepCompletable, formatMessage = _a.formatMessage;
            var userTenant = authentication.userTenant();
            if (userTenant.settings.signUpOption === SSO_TYPE_SAML) {
                setIsStepCompletable(true);
                notify.success({ message: formatMessage({ id: "setup_tenant.steps.setupSSO.successMessage" }) });
            }
        };
        return _this;
    }
    PromoMaterials.prototype.render = function () {
        var userTenant = authentication.userTenant();
        return (React.createElement(React.Fragment, null,
            React.createElement(SAMLSingleSignOn, { ssoButtonText: userTenant.settings.ssoButtonText, userTenant: userTenant, handleSave: this.checkIfStepIsCompletable, hideDocHint: true })));
    };
    return PromoMaterials;
}(PureComponent));
export default injectIntl(PromoMaterials);
